import React from 'react';
import Seo from '../components/Seo';
import SectionContact from '../components/SectionContact';
import Bande from '../components/Bande';
import Reveal from '../components/Reveal';
import TitreSection from '../components/TitreSection';
import CarteMachine from '../components/CarteMachine';
import CarteAccessoire from '../components/CarteAccessoire';
import AppelAction from '../components/AppelAction';
import Faq from '../components/Faq';
import Avis from '../components/Avis';
import { MACHINES, ACCESSOIRES, FAQ } from '../data/site';

export default function NosEngins() {
  const pelles = MACHINES.filter((m) => m.famille === 'pelles');
  const manut = MACHINES.filter((m) => m.famille === 'manutention');
  const hauteur = MACHINES.filter((m) => m.famille === 'elevation');
  const energie = MACHINES.filter((m) => m.famille === 'energie');

  return (
    <>
      <Seo
        titre="Nos engins de chantier à louer | Mini-pelles, chariots, nacelle"
        description="Mini-pelles Volvo et Sunward, chariot télescopique JCB, chariot élévateur, nacelle élévatrice et compresseur en location à Alfortville (94). Avec ou sans chauffeur."
      />

      <section className="bg-nuit text-white relative overflow-hidden">
        <div className="absolute inset-0 trame-diagonale" aria-hidden="true" />
        <div className="conteneur relative py-14 sm:py-16">
          <h1 className="font-display uppercase text-[36px] sm:text-[48px] leading-[1] max-w-3xl">
            Toutes nos <span className="mot-degrade">machines</span>, avec leurs vrais chiffres
          </h1>
          <p className="mt-5 text-white/75 max-w-2xl text-[18px]">
            Dix-huit machines au parc, du terrassement au travail en hauteur. Pour les
            principales, on publie tout : tonnage, largeur hors-tout, profondeur de fouille,
            hauteur de levage, CACES requis. De quoi décider si la machine passe chez vous
            avant même de nous appeler.
          </p>
        </div>
        <Bande hauteur={6} />
      </section>

      <section className="bg-trame py-14 sm:py-16">
        <div className="conteneur">
          <TitreSection avant="Mini-pelles à rayon " mot="court" />
          <p className="mt-4 max-w-2xl text-nuit/75">
            Le rayon court, c'est ce qui permet de travailler le long d'un mur ou d'une clôture
            sans que la tourelle déborde derrière les chenilles. Sur un chantier urbain, ça change tout.
          </p>
          <div className="mt-9 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {pelles.map((m) => (
              <Reveal key={m.slug}><CarteMachine machine={m} /></Reveal>
            ))}
          </div>
        </div>
      </section>

      <AppelAction titre="Vous hésitez entre la 2,5 et la 5 tonnes ?" texte="Donnez-nous la profondeur de fouille et la largeur de l'accès, on tranche pour vous en deux minutes." />

      <section className="bg-white py-14 sm:py-16">
        <div className="conteneur">
          <TitreSection avant="Manutention et " mot="levage" />
          <p className="mt-4 max-w-2xl text-nuit/75">
            Pour approvisionner un chantier, décharger un camion ou reprendre du stock en entrepôt,
            sans mobiliser une grue. Le télescopique porte loin et haut, le chariot frontal fait
            le travail quotidien de manutention.
          </p>
          <div className="mt-9 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {manut.map((m) => (
              <Reveal key={m.slug}><CarteMachine machine={m} /></Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-trame py-14 sm:py-16">
        <div className="conteneur">
          <TitreSection avant="Travail en hauteur et air " mot="comprimé" />
          <p className="mt-4 max-w-2xl text-nuit/75">
            Deux besoins qui reviennent sur presque tous les chantiers, et pour lesquels
            appeler un second loueur fait perdre une demi-journée.
          </p>
          <div className="mt-9 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {[...hauteur, ...energie].map((m) => (
              <Reveal key={m.slug}><CarteMachine machine={m} /></Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white py-14 sm:py-16">
        <div className="conteneur">
          <TitreSection avant="Les accessoires qui changent le " mot="chantier" />
          <div className="mt-9 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {ACCESSOIRES.map((a, i) => (
              <Reveal key={a.nom} delai={i * 0.06}>
                <CarteAccessoire accessoire={a} hauteur={210} />
              </Reveal>
            ))}
          </div>
          <p className="mt-7 max-w-2xl text-nuit/75">
            Notre parc compte dix-huit machines et un jeu complet d'accessoires. Si vous
            cherchez un tonnage ou un équipement qui ne figure pas sur cette page,
            appelez-nous : il y a de fortes chances que nous l'ayons.
          </p>
        </div>
      </section>

      <AppelAction variante="sombre" />
      <Avis />
      <Faq />
      <SectionContact
        avant="Une machine en tête, ou aucune "
        mot="idée ?"
        intro="Les deux nous vont. Décrivez le chantier, la largeur de votre accès et vos dates, on vous dit ce qui passe et on vous envoie le tarif en quelques heures."
      />
    </>
  );
}
